import * as React from 'react';


type WindowRedirectProps = {
   url: string;
   beforeRedirect?: () => void;
}

class WindowRedirect extends React.Component<WindowRedirectProps> {

   componentDidMount() {
      const {beforeRedirect} = this.props;
      beforeRedirect && beforeRedirect();
      window.location = this.props.url;
   }

   render() {
      return null;
   }
}


export function createWindowRedirect(url: string, beforeRedirect?: () => void) {
   return () => (
      <WindowRedirect url={url} beforeRedirect={beforeRedirect}/>
   )
}